export default __webpack_public_path__ + "static/media/NOTO_SANS_JP.888811d5.ttf";